import { Pipe, PipeTransform } from '@angular/core';
import { Injectable } from '@angular/core';
import {
  UtilFunctions,
  stringify,
  isBlank
} from '../components/new-navigation/util-functions';

@Pipe({ name: 'show' })
@Injectable()
export class ShowPipe implements PipeTransform {
  transform(value: any, arg0: string): any {
    if (isBlank(arg0)) {
      throw new Error('Show pipe requires one argument');
    }

    let argArray = arg0.split(',');
    let showMore = argArray[0] === 'true';
    let limit = parseInt(argArray[1]);

    if (!this.supports(value)) {
      return 'N/A';
      //throw new InvalidPipeArgumentException(ShowPipe, value);
    }
    if (isBlank(value)) return value;
    var showAll: boolean = showMore;
    if (showAll) {
      return value;
    }
    var ilimit: number = limit ? limit : null;
    if (UtilFunctions.isString(value)) {
      return value.substr(0, ilimit);
    }
    return value.slice(0, ilimit);
  }

  private supports(obj: any): boolean {
    return UtilFunctions.isString(obj) || Array.isArray(obj);
  }
}

export class InvalidPipeArgumentException extends Error {
  constructor(type, value) {
    super(
      "Invalid argument '" + value + "' for pipe '" + stringify(type) + "'"
    );
  }
}
